/**
 *
 * Hash File
 *
 * takes a file and generates a sha256 unique hash.
 * carefully does this the same way as the server function.
 *
 */
export async function hashFile(file) {
  const buf = await file.arrayBuffer()
  const hashBuf = await crypto.subtle.digest('SHA-256', buf)
  const hash = Array.from(new Uint8Array(hashBuf))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
  return hash
}

export function getInscriptionIdFromURL() {
  if (!window?.location?.pathname) return null
  const path = window.location.pathname // e.g., "/world/abc123" or "/world"
  const segments = path.split('/').filter(Boolean)

  if (segments[0] === 'world') {
    return segments[2] || null // Return the inscription ID if it exists
  }
  return null
}
